module.exports = __webpack_public_path__ + "static/media/error.eabe7468.svg";